import {IWithSummaryModel} from "../../../../../common/permission/api/entity/iWithSummary.model";
import {LovValueSummary} from "../../../../../common/lov/lov-value/api/model/lovValueSummary.model";
import {InsolesProviderModelSummaryModel} from "./insolesProviderModelSummary.model";
import {ProviderServiceSummaryModel} from "../../../../../provider/service/api/entity/providerServiceSummary.model";
import {InsolesModelModel} from "../../../../insolemodel/api/entity/insolesModel.model";
import {InsolesProviderModelMaterialConverter} from "./insolesProviderModelMaterial.converter";
import {InsolesProviderModelMaterialModel} from "./insolesProviderModelMaterial.model";
import {ProviderSummaryModel} from "../../../../../provider/common/api/entity/providerSummary.model";
import {InsolesProviderModelGabaritModel} from "./insolesProviderModelGabarit.model";
import {InsolesProviderModelCamMachineModel} from "./insolesProviderModelCamMachine.model";

export class InsolesProviderModelModel implements IWithSummaryModel<InsolesProviderModelSummaryModel>{
    summary: InsolesProviderModelSummaryModel;
    model: InsolesModelModel;
    nbDaysToAchieve: number;
    materials: InsolesProviderModelMaterialModel[] = [];
    gabarits: InsolesProviderModelGabaritModel[] = [];
    camMachines: InsolesProviderModelCamMachineModel[] =[];
    providerService: ProviderServiceSummaryModel;
    camConfig: string;
    labelTemplate: string;

}